/* eslint-disable react/no-danger */
/* eslint-disable react/require-default-props */
import React from 'react';
import { useSelector } from 'react-redux';
import FavoriteButton from 'components/atoms/favorite_button';
import BiddingManageButton from 'components/atoms/bidding_manage_button';
import CardCounter from 'components/atoms/card_counter';
import SelectButton from 'components/atoms/select_button';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { GestaoTypes } from 'store/modules/bidding_store/types';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { Container } from './styles';
import VisualizeButton from '../visualize_button';

interface BiddingHeaderNewProps {
  biddingId: string;
  biddingIndex: number;
  isChecked: boolean;
  isFavorited: boolean;
  isViewed?: boolean;
  isViewedBy?: Array<string>;
  source?: string;
  contactList: Array<string>;
  toggleSelected: (id: number, updateAll?: boolean) => void;
  favoritedSource: string;
  bulletinFilterId?: number;
  situation: string;
  sessionStatus?: string;
  gestao?: GestaoTypes;
}

const BiddingHeaderNew: React.FC<BiddingHeaderNewProps> = (props: BiddingHeaderNewProps) => {
  const {
    biddingId,
    biddingIndex,
    isChecked,
    isFavorited,
    isViewed = false,
    isViewedBy,
    source = 'biddings',
    contactList,
    favoritedSource,
    toggleSelected,
    bulletinFilterId = 0,
    situation,
    sessionStatus,
    gestao,
  } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const isAlfa = profile?.alfa_tester === true;
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  const blockLocked = (event: React.SyntheticEvent) => {
    if (!isOnlyConlicitaseg) return;

    event.preventDefault();
    event.stopPropagation();
  };

  const lockProps = {
    style: { display: 'contents' },
    className: isOnlyConlicitaseg ? 'locked-actions' : '',
    'aria-disabled': isOnlyConlicitaseg,
    onClickCapture: blockLocked,
  };

  return (
    <Container>
      <div
        className={`card-header bidding-bg-header bidding-info ${
          (source === 'management' || source === 'imminence') && 'rounded-top'
        }`}
      >
        <div className="row align-items-center">
          {(source === 'biddings' ||
            source === 'bulletin' ||
            source === 'share' ||
            source === 'favorited') && <CardCounter count={biddingIndex + 1} />}
          <div className="d-flex mr-auto align-items-center">
            <div className="bidding-item-header-buttons mb-2 mb-md-0 d-print-none">
              {(source === 'biddings' || source === 'bulletin' || source === 'favorited') && (
                <div
                  className="position-relative databalloon tour-remove-favorites-select-one"
                  aria-label="Selecionar licitação"
                  data-balloon-pos="up"
                >
                  <SelectButton
                    id={parseInt(biddingId, 10)}
                    isChecked={isChecked}
                    toggleSelected={toggleSelected}
                    text=""
                  />
                </div>
              )}
              {source !== 'share' && !isAlfa && (
                <div {...lockProps}>
                  <FavoriteButton
                    biddingId={biddingId}
                    isFavorited={isFavorited}
                    favoritedSource={favoritedSource}
                    bulletinFilterId={bulletinFilterId}
                    source={source}
                    contactList={contactList}
                  />
                </div>
              )}
            </div>

            {source !== 'share' && isAlfa && (
              <div {...lockProps}>
                <BiddingManageButton biddingId={biddingId} source={source} gestao={gestao} />
              </div>
            )}
            {source === 'bulletin' && (
              <div className="m-0 d-flex align-items-center">
                <VisualizeButton
                  biddingId={biddingId}
                  isViewed={isViewed}
                  bulletinFilterId={bulletinFilterId}
                  isViewedBy={isViewedBy}
                />
              </div>
            )}
          </div>

          <div className="ml-2 text-white mr-2">
            <span
              className={`rounded mr-2 bidding-situation-${situation?.replace(
                /\s/g,
                '-',
              )}`.toLowerCase()}
              dangerouslySetInnerHTML={{
                __html: situation || '-',
              }}
            />
            {sessionStatus && (
              <span
                className="rounded mr-2 bg-secondary p-1 text-uppercase"
                dangerouslySetInnerHTML={{ __html: sessionStatus }}
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BiddingHeaderNew;
